/**
 * NotificationsCenter — activity type metadata
 * ============================================
 * Iter-349 Part 13 (Frontend Perf) — extracted from `NotificationsCenter.jsx`
 * to keep the parent under the 400 LOC ratchet baseline.
 *
 * Maps notification `type` strings to icon + Tailwind colour classes.
 */
import {
  CheckCircle2, Target, ClipboardCheck, TrendingUp, AlertTriangle,
  Users, Sparkles, DollarSign, MessageSquare, FileText, Star, UserPlus,
} from 'lucide-react';

export const ACTIVITY_TYPES = {
  task: { icon: CheckCircle2, color: 'emerald', bgColor: 'bg-emerald-100', textColor: 'text-emerald-600' },
  task_completed: { icon: CheckCircle2, color: 'emerald', bgColor: 'bg-emerald-100', textColor: 'text-emerald-600' },
  milestone: { icon: Target, color: 'purple', bgColor: 'bg-purple-100', textColor: 'text-purple-600' },
  task_assigned: { icon: ClipboardCheck, color: 'blue', bgColor: 'bg-blue-100', textColor: 'text-blue-600' },
  kpi: { icon: TrendingUp, color: 'blue', bgColor: 'bg-blue-100', textColor: 'text-blue-600' },
  alert: { icon: AlertTriangle, color: 'amber', bgColor: 'bg-amber-100', textColor: 'text-amber-600' },
  team: { icon: Users, color: 'purple', bgColor: 'bg-purple-100', textColor: 'text-purple-600' },
  insight: { icon: Sparkles, color: 'primary', bgColor: 'bg-primary/10', textColor: 'text-primary' },
  revenue: { icon: DollarSign, color: 'green', bgColor: 'bg-green-100', textColor: 'text-green-600' },
  feedback: { icon: MessageSquare, color: 'pink', bgColor: 'bg-pink-100', textColor: 'text-pink-600' },
  report: { icon: FileText, color: 'slate', bgColor: 'bg-slate-100', textColor: 'text-slate-600' },
  achievement: { icon: Star, color: 'yellow', bgColor: 'bg-yellow-100', textColor: 'text-yellow-600' },
  staff_update: { icon: UserPlus, color: 'indigo', bgColor: 'bg-indigo-100', textColor: 'text-indigo-600' },
};
